import { Params } from '@angular/router';

export class Breadcrumb
{
	constructor(label: string, params: Params, url: string)
	{
		this.label = label;
		this.params = params;
		this.url = url;
	}

	label: string;
	params: Params;
	url: string;
}



// WEBPACK FOOTER //
// ./src/app/models/breadcrumb.ts